<header>
  <div class="header-wrapper">
    <div style="height: 58px">
      <div class="tabs-container">
        <ul class="nav nav-pills" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              [class.active]="selectedStatusFilter === 'active'"
              type="button"
              style="width: 140px"
              (click)="setStatusFilter('active')"
            >
              Active
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              [class.active]="selectedStatusFilter === 'inactive'"
              type="button"
              style="width: 110px"
              (click)="setStatusFilter('inactive')"
            >
              Inactive
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              [class.active]="selectedStatusFilter === 'all'"
              type="button"
              style="width: 70px"
              (click)="setStatusFilter('all')"
            >
              All
            </button>
          </li>
        </ul>
        <div class="search-bar me-2" style="border: 1px solid #dee2e6">
          <input
            #passcodeSearchInput
            type="text"
            class="form-control"
            placeholder="Search User..."
            autocomplete="new-password"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            [attr.readonly]="isSearchReadonly ? '' : null"
            (focus)="enableSearchInput()"
            [ngModel]="searchText"
            (ngModelChange)="searchText = $event"
            style="height: 35px; border: none"
          />
          <img src="/assets/images/search.svg" alt="" style="height: 13px; width: 13px" />
        </div>
      </div>
    </div>
  </div>
</header>

<section>
  <div id="tabContent">
    <div class="first-section">
      <span class="tab-heading">
        {{ isManagingOtherUser ? 'Passcode Settings' + (targetUserName ? ' — ' + targetUserName : '') : 'User Passcode Settings' }}
      </span>

      <div class="sorting-wrap">
        <button
          class="btn text-nowrap ms-2"
          type="button"
          (click)="openCreatePasscodeSheet()"
          data-bs-toggle="offcanvas"
          data-bs-target="#addPasscodeSheet"
          aria-controls="addPasscodeSheet"
        >
          Create Passcode
        </button>
      </div>
    </div>

    <div class="table-container">
      <table class="table">
        <thead class="sticky-top" style="z-index: 9">
          <tr>
            <th scope="col" class="ps-3">Name</th>
            <th scope="col">Passcode</th>
            <th scope="col">Expire Date</th>
            <th scope="col" class="text-center">Action</th>
            <th scope="col" class="text-center">Active</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of filteredPasscodeRows">
            <td class="ps-3">{{ row.name }}</td>
            <td class="text-start c-pt">
              <div class="passcode-cell">
                <span>{{ getDisplayedPasscode(row) }}</span>
                <button
                  type="button"
                  class="passcode-visibility-btn"
                  (click)="togglePasscodeVisibility(row.id)"
                  [attr.aria-label]="isPasscodeVisible(row.id) ? 'Hide passcode' : 'Show passcode'"
                >
                  <i
                    class="fa-regular"
                    [ngClass]="isPasscodeVisible(row.id) ? 'fa-eye-slash' : 'fa-eye'"
                  ></i>
                </button>
              </div>
            </td>
            <td>{{ row.expiresAt | date: 'MM/dd/yyyy' }}</td>
            <td class="text-center c-pt">
              <img
                src="/assets/images/newediticon.svg"
                alt="Edit"
                (click)="openEditPasscodeSheet(row)"
                data-bs-toggle="offcanvas"
                data-bs-target="#addPasscodeSheet"
                aria-controls="addPasscodeSheet"
              />
            </td>
            <td class="text-center active-passcode">
              <div class="form-check form-switch d-flex justify-content-center">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="row.isActive"
                  (change)="onChangePasscodeStatus(row, $event)"
                />
              </div>
            </td>
          </tr>
          <tr *ngIf="filteredPasscodeRows.length === 0">
            <td colspan="5" class="text-center text-muted py-4">No passcodes found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>

<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="addPasscodeSheet"
  aria-labelledby="addPasscodeSheetLabel"
  data-bs-backdrop="static"
>
  <div class="offcanvas-header px-0">
    <h5 class="mb-0 offcanvas-title" id="addPasscodeSheetLabel">
      {{ isEditMode ? 'Update User Passcode' : 'Add User Passcode' }}
    </h5>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>

  <div class="offcanvas-body px-0 pb-0">
    <div class="passcode-form-wrap">
      <div class="mb-3">
        <label for="passcodeName" class="form-label">Name <span class="text-danger">*</span></label>
        <input
          type="text"
          class="form-control"
          id="passcodeName"
          placeholder="Enter passcode name"
          [(ngModel)]="passcodeForm.name"
          name="passcodeName"
          required
          #nameField="ngModel"
          [class.is-invalid]="nameField.invalid && (nameField.dirty || nameField.touched || formSubmitted)"
        />
        <div class="invalid-feedback">
          Name is required.
        </div>
      </div>

      <div class="mb-3">
        <label for="passcodeValue" class="form-label">Passcode <span class="text-danger">*</span></label>
        <div class="input-group" [class.is-invalid]="passcodeField.invalid && (passcodeField.dirty || passcodeField.touched || formSubmitted)">
          <input
            [type]="showFormPasscode ? 'text' : 'password'"
            class="form-control"
            id="passcodeValue"
            placeholder="Enter 4–6 digit PIN"
            [(ngModel)]="passcodeForm.passcode"
            name="passcodeValue"
            required
            pattern="^[0-9]{4,6}$"
            #passcodeField="ngModel"
            [class.is-invalid]="passcodeField.invalid && (passcodeField.dirty || passcodeField.touched || formSubmitted)"
          />
          <button
            type="button"
            class="btn btn-outline-secondary passcode-form-toggle-btn"
            (click)="showFormPasscode = !showFormPasscode"
            [attr.aria-label]="showFormPasscode ? 'Hide passcode' : 'Show passcode'"
          >
            <i class="fa-regular" [ngClass]="showFormPasscode ? 'fa-eye-slash' : 'fa-eye'"></i>
          </button>
        </div>
        <div class="invalid-feedback" [class.d-block]="passcodeField.invalid && (passcodeField.dirty || passcodeField.touched || formSubmitted)">
          <ng-container *ngIf="passcodeField.errors?.['required']">Passcode is required.</ng-container>
          <ng-container *ngIf="passcodeField.errors?.['pattern']">Passcode must be 4–6 digits (numbers only).</ng-container>
        </div>
      </div>

      <div class="mb-3">
        <label for="expireDate" class="form-label">Expire Date <span class="text-danger">*</span></label>
        <input
          type="date"
          class="form-control"
          id="expireDate"
          [(ngModel)]="passcodeForm.expiresAt"
          name="expireDate"
          required
          #expireDateField="ngModel"
          [class.is-invalid]="expireDateField.invalid && (expireDateField.dirty || expireDateField.touched || formSubmitted)"
        />
        <div class="invalid-feedback">
          Expire Date is required.
        </div>
      </div>
    </div>

    <div class="passcode-footer modal-footer justify-content-end pb-0 mt-0 px-0 pt-2">
      <button
        type="button"
        class="d-none"
        #closePasscodeSheetBtn
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
      <button type="button" class="btn cancel-btn" data-bs-dismiss="offcanvas">
        Cancel
      </button>
      <button type="button" class="btn save-btn ms-2" (click)="saveOrUpdatePasscode()" [disabled]="isSaving || nameField.invalid || passcodeField.invalid || expireDateField.invalid">
        {{ isEditMode ? 'Update' : 'Save' }}
      </button>
    </div>
  </div>
</div>
